import { useDevicesScreen } from '../../../../utils/useDevicesScreen';

import app from '@frontastic/catwalk/src/js/app/app';
import { useCustomScrollToTop } from '../../../../utils/useCustomScrollToTop';
import { Text } from '../../../typography/text/Text';
import Pagination from '../../pagination/Pagination';
import ArticleTile from '../articleTile';
import JournalTeaser from '../journalTeaser';
import { theme } from './_vars';
import styles from './ArticlesGrid.module.scss';

import { Article } from '@srcDS/js/components/templates/journal/journalCategory/JournalCategory';

export interface PaginationState {
  total: number;
  limit: number;
  skip: number;
  [key: string]: any;
}

export interface PaginationClickState {
  selected: number;
}

export interface TeaserMedia {
  desktop?: { url: string };
  tablet?: { url: string };
  mobile?: { url: string };
}

export interface JournalTeaserProps {
  media?: TeaserMedia;
  [key: string]: any;
}

export interface ArticlesGridProps {
  articles?: Article[];
  teaser?: JournalTeaserProps;
  isSSR: boolean;
  paginationState?: PaginationState;
  articleSection?: string;
}

const ArticlesGrid = ({ articles = [], teaser, isSSR, paginationState, articleSection }) => {
  const { isMobile } = useDevicesScreen();
  const { goToTop } = useCustomScrollToTop(null, 'auto');
  const { total, limit, skip } = paginationState || {};
  const initialPage = skip === 0 ? 1 : Math.ceil((skip + limit) / limit);

  const handlePageClick = (state) => {
    const selected = state.selected + 1;
    app.getRouter().history.replace(`?page=${selected}`);
    goToTop();
  };

  const hasTeaserMedia = teaser?.media?.desktop?.url || teaser?.media?.tablet?.url || teaser?.media?.mobile?.url;

  return (
    <div className={styles.container}>
      {/*@ts-ignore*/}
      {theme === 'sportscraft' && (
        <div className={styles.gridTitle}>
          <span className={styles.line} />
          <Text as="h4" size="xxl" textTransform="firstletter">
            Latest articles
          </Text>
          <span className={styles.line} />
        </div>
      )}
      <div className={styles.listContainer}>
        {teaser && initialPage === 1 && hasTeaserMedia && (
          <JournalTeaser {...teaser} isSSR={isSSR} articlesCount={articles.length} />
        )}
        {articles.map((item, index) => (
          <ArticleTile key={index + articles?.[0]?.title} {...item} categories={item.categories || articleSection} isSSR={isSSR} inGrid />
        ))}
      </div>
      {paginationState && total > limit && (
        <div className={styles.paginationWrapper}>
          <Pagination
            pageCount={Math.ceil(total / limit)}
            initialPage={initialPage}
            handlePageClick={handlePageClick}
          />
        </div>
      )}
    </div>
  );
};

ArticlesGrid.propTypes = {};

export default ArticlesGrid;
